import axios from 'axios';
import { LOCALE_STORAGE_KEY } from '../i18n/locales';

const TOKEN_STORAGE_KEY = 'tavern_token';

const getCurrentLocale = () => {
  if (typeof window === 'undefined') return 'en';

  const storedLocale =
    window.localStorage?.getItem(LOCALE_STORAGE_KEY) ||
    document.documentElement.lang ||
    navigator.language ||
    'en';
  const locale = storedLocale.split(/[-_]/)[0] || 'en';

  return ['en', 'fr'].includes(locale) ? locale : 'en';
};

export const authHeaders = () => {
  const token = window.localStorage.getItem(TOKEN_STORAGE_KEY);

  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    'X-Tavern-Locale': getCurrentLocale(),
  };
};

const requestMethod = (method) => String(method || 'GET').toUpperCase();

const enrichApiError = (error, fallback = {}) => {
  if (!error || typeof error !== 'object') return error;

  const config = error.config || {};
  const response = error.response || {};
  const headers = response.headers || {};

  error.tavernReport = {
    method: requestMethod(config.method || fallback.method),
    endpoint: config.url || fallback.url || '',
    status: response.status || error.code || 'network',
    requestId:
      headers['x-request-id'] ||
      headers['X-Request-Id'] ||
      response.data?.requestId ||
      '',
    errorMessage: response.data?.error || error.message || 'Unknown API error',
  };

  return error;
};

const requestData = async (request, fallback) => {
  try {
    const response = await request();
    return response.data;
  } catch (error) {
    throw enrichApiError(error, fallback);
  }
};

export const getAuthenticated = async (url, config = {}) => {
  return requestData(
    () =>
      axios.get(url, {
        ...config,
        headers: {
          ...authHeaders(),
          ...config.headers,
        },
      }),
    { method: 'GET', url }
  );
};

export const postAuthenticated = async (url, data, config = {}) => {
  return requestData(
    () =>
      axios.post(url, data, {
        ...config,
        headers: {
          ...authHeaders(),
          ...config.headers,
        },
      }),
    { method: 'POST', url }
  );
};

export const patchAuthenticated = async (url, data, config = {}) => {
  return requestData(
    () =>
      axios.patch(url, data, {
        ...config,
        headers: {
          ...authHeaders(),
          ...config.headers,
        },
      }),
    { method: 'PATCH', url }
  );
};

export const putAuthenticated = async (url, data, config = {}) => {
  return requestData(
    () =>
      axios.put(url, data, {
        ...config,
        headers: {
          ...authHeaders(),
          ...config.headers,
        },
      }),
    { method: 'PUT', url }
  );
};

export const deleteAuthenticated = async (url, config = {}) => {
  return requestData(
    () =>
      axios.delete(url, {
        ...config,
        headers: {
          ...authHeaders(),
          ...config.headers,
        },
      }),
    { method: 'DELETE', url }
  );
};
